module.exports = __webpack_public_path__ + "img/canyon_brown_ba_list.d2e8fe12.jpg";